import { createTheme } from "@mui/material";

import getMuiButtonOverride from "./getMuiButtonOverride";
import getTypographyOverrides from "./getTypographyOverrides";
import getMuiChipOverride from "./getMuiChipOverride";
import getMuiCheckboxOverride from "./getMuiCheckboxOverride";
import getMuiTextfieldOverride from "./getMuiTextfieldOverride";
import getMuiTableCellOverride from "./getMuiTableCellOverride";
import getMuiTableRowOverride from "./getMuiTableRowOverride";
import getMuiPaperOverride from "./getMuiPaperOverride";
import getMuiLinkOverride from "./getMuiLinkOverride";
import getMuiCircularProgressOverride from "./getMuiCircularProgressOverride";
import getMuiSwitchOverride from "./getMuiSwitchOverride";
import getMuiRadioOverride from "./getMuiRadioOverride";

const customTheme = createTheme({
  components: {
    MuiButton: getMuiButtonOverride(),
    MuiChip: getMuiChipOverride(),
    MuiCheckbox: getMuiCheckboxOverride(),
    MuiRadio: getMuiRadioOverride(),
    MuiTextField: getMuiTextfieldOverride(),
    MuiTableCell: getMuiTableCellOverride(),
    MuiTableRow: getMuiTableRowOverride(),
    MuiPaper: getMuiPaperOverride(),
    MuiLink: getMuiLinkOverride(),
    MuiCircularProgress: getMuiCircularProgressOverride(),
    MuiSwitch: getMuiSwitchOverride(),
  },
  typography: getTypographyOverrides(),
  palette: {
    secondary: {
      main: "#2B244C"
    }
  }
})


export default customTheme

